import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import Banner from 'components/common/Banner/Banner'
import { showRecoveryModal } from '../../actions'

const Expired = ({
  path,
  expiredError,
  showRecoveryModal
}) =>
  <React.Fragment>
    <Banner error_alternative hidden={ !expiredError }>
      { expiredError }
    </Banner>
    <Button full="mobile" narrow onClick={ () => showRecoveryModal(path) }>Forgot Password</Button>
  </React.Fragment>

Expired.propTypes = {
  expiredError: PropTypes.string,
  path: PropTypes.string,
  showRecoveryModal: PropTypes.func
}

export default connect(null, { showRecoveryModal })(Expired)
